import { render, staticRenderFns } from "./infoDetail.vue?vue&type=template&id=38411676&scoped=true"
import script from "./infoDetail.vue?vue&type=script&lang=js"
export * from "./infoDetail.vue?vue&type=script&lang=js"
import style0 from "./infoDetail.vue?vue&type=style&index=0&id=38411676&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38411676",
  null
  
)

export default component.exports